import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface RunExtractRefreshesOnPublishedConnectionParams {
  level: string;
  startingItems: string[];
  targetId: string;
  type: string; // ExtractTaskType
}

export class RunExtractRefreshesOnPublishedConnectionRequest extends Request<RunExtractRefreshesOnPublishedConnectionParams, IResult> {
  constructor(params: RunExtractRefreshesOnPublishedConnectionParams) {
    super('runExtractRefreshesOnPublishedConnection', params);
  }
}
